import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import GuestRoute from './components/GuestRoute/GuestRoute';
import CheckIfLoggedIn from './components/CheckIfLoggedIn/CheckIfLoggedIn';

import LoginPage from './pages/Login/Login';
import ForgotPasswordPage from './pages/Login/ForgotPassword';
import ResetPasswordPage from './pages/ResetPassord';
import RegisterPage from './pages/Register/Register';
import PageNotFound from './pages/NotFound/NotFound';
import ProfilePage from './pages/Profile';
import AdminPage from './pages/Admin';
import VerifySingUp from './pages/VerifySignUp';

import ContractorCreatePage from './pages/Contractor/CreateContractor';
import ContractorEditPage from './pages/Contractor/Edit';
import ListContractors from './pages/Contractor/ListContractors';
import ContractorView from './pages/Contractor/ViewPage';

import TemplateCreatePage from './pages/Template/Create';
import ListTemplates from './pages/Template/List';
import TemplateView from './pages/Template/View';
import TemplateEdit from './pages/Template/Edit';

import MapList from './pages/Map/MapList';
import GuestMapList from './pages/Map/GuestMapList';
import PlanCreatePage from './pages/Plan/Create';
import ListPlans from './pages/Plan/List';
import PlanView from './pages/Plan/View';
import PlanAdminView from './pages/Plan/AdminView';
import PlanEditPage from './pages/Plan/Edit';
import SendToEmail from './pages/Plan/SendToEmail';
import AssistantPage from './pages/Assistant';
import PersonalAssistant from './pages/PersonalAssistant';
import ListAssistantChat from './pages/Assistant/List';
import AssistantChatView from './pages/Assistant/View';
import ListUsers from './pages/Users/List';
import UserView from './pages/Users/View';
import UserEditPage from './pages/Users/Edit';
import ListDirectories from './pages/Directory/List';
import DirectoryEditPage from './pages/Directory/Edit';
import DirectoryCreatePage from './pages/Directory/Create';
import DirectoryView from './pages/Directory/View';

import PlansList from './pages/PlansList/List';
import GenerationsList from './pages/Generations/List';
import MyPlans from './pages/MyPlans/List';
import ProductsOfConfigurator from './pages/Products/ProductsOfConfigurators';

const App = props => {
  return (
    <ConnectedRouter history={props.history}>
      <CheckIfLoggedIn>
        <Switch>
          <PrivateRoute exact path="/" component={MapList} />
          <PrivateRoute exact path="/my-plans" component={MyPlans} />

          <GuestRoute exact path="/plans" component={GuestMapList} />

          <PrivateRoute exact path="/admin" component={AdminPage} permission={['ADMIN']} />
          <PrivateRoute
            exact
            path="/admin-assistant"
            component={AssistantPage}
            permission={['ADMIN']}
          />

          <PrivateRoute
            exact
            path="/admin/products-of-configurators"
            component={ProductsOfConfigurator}
            permission={['ADMIN']}
          />

          <PrivateRoute
            exact
            path="/admin/contractor/new"
            component={ContractorCreatePage}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/contractor/edit/:id"
            component={ContractorEditPage}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/contractors"
            component={ListContractors}
            permission={['ADMIN']}
          />
          <PrivateRoute exact path="/contractor/:id" component={ContractorView} />

          <PrivateRoute exact path="/profile" component={ProfilePage} />
          <GuestRoute exact path="/login" component={LoginPage} />
          <GuestRoute exact path="/forgot-password" component={ForgotPasswordPage} />
          <GuestRoute exact path="/reset-password/:token" component={ResetPasswordPage} />
          <GuestRoute exact path="/register" component={RegisterPage} />

          <PrivateRoute
            exact
            path="/admin/sorting-hat/new"
            component={TemplateCreatePage}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/sorting-hat/edit/:id"
            component={TemplateEdit}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/sorting-hats"
            component={ListTemplates}
            permission={['ADMIN']}
          />
          <Route exact path="/sorting-hat/:id" component={TemplateView} />

          <PrivateRoute exact path="/admin/users" component={ListUsers} permission={['ADMIN']} />
          <PrivateRoute
            exact
            path="/admin/plans-lists"
            component={PlansList}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/generations"
            component={GenerationsList}
            permission={['ADMIN']}
          />

          <PrivateRoute exact path="/user/:id" component={UserView} permission={['ADMIN']} />
          <PrivateRoute
            exact
            path="/admin/user/edit/:id"
            component={UserEditPage}
            permission={['ADMIN']}
          />

          <PrivateRoute
            exact
            path="/admin/assistant-сhats"
            component={ListAssistantChat}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/assistant-сhat/:id"
            component={AssistantChatView}
            permission={['ADMIN']}
          />

          <PrivateRoute
            exact
            path="/admin/plan/new"
            component={PlanCreatePage}
            permission={['ADMIN']}
          />
          <PrivateRoute exact path="/admin/plans" component={ListPlans} permission={['ADMIN']} />

          <PrivateRoute
            exact
            path="/admin/plan/edit/:id"
            component={PlanEditPage}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/plan/view/:id"
            component={PlanAdminView}
            permission={['ADMIN']}
          />

          <PrivateRoute
            exact
            path="/admin/directories"
            component={ListDirectories}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/directory/edit/:id"
            component={DirectoryEditPage}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/admin/directory/new"
            component={DirectoryCreatePage}
            permission={['ADMIN']}
          />
          <PrivateRoute
            exact
            path="/directory/:id"
            component={DirectoryView}
            permission={['ADMIN']}
          />

          <PrivateRoute exact path="/map-list" component={MapList} />
          <Route exact path="/plan/:id/:mapId?" component={PlanView} />
          <Route exact path="/plan-send-to-email" component={SendToEmail} />

          <Route exact path="/verify-sign-up/:token" component={VerifySingUp} />

          <Route exact path="/personal-assistant" component={PersonalAssistant} />
          <Route exact path="/assistant" component={PersonalAssistant} />

          <Route component={PageNotFound} />
        </Switch>
      </CheckIfLoggedIn>
    </ConnectedRouter>
  );
};

App.propTypes = {
  history: PropTypes.object
};

export default App;
